import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

const AlertService = {
  success: (message: string, title = "Success") => {
    Swal.fire({
      icon: "success",
      title,
      text: message,
      confirmButtonColor: "#3085d6",
    });
  },

  error: (message: string, title = "Error") => {
    Swal.fire({
      icon: "error",
      title,
      text: message,
      confirmButtonColor: "#d33",
    });
  },

  warning: (message: string, title = "Warning") => {
    Swal.fire({
      icon: "warning",
      title,
      text: message,
      confirmButtonColor: "#f0ad4e",
    });
  },

  confirm: async (message: string, title = "Are you sure?") => {
    const result = await Swal.fire({
      title,
      text: message,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
    });
    return result.isConfirmed;
  },

  info: (message: string, title = "Information") => {
    Swal.fire({
      icon: "info",
      title,
      text: message,
      confirmButtonColor: "#3085d6",
    });
  },
};

export default AlertService;
